import { ColorPicker, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { WorkspaceSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function WorkspaceFormGeneral() {
	/** Context */
	const methods = useFormContext<WorkspaceSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-6">
			<TextInput
				label={t("organization.workspace")}
				control={methods.control}
				name="name"
				placeholder={t("placeholders.company_name")}
				isRequired
				data-cy="workspace-name-input"
			/>
			<ColorPicker
				label={t("organization.organization_color")}
				name="color"
				control={methods.control}
				isRequired={false}
				data-cy="workspace-color-picker"
			/>
		</div>
	);
}
